import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeasurementStandardListComponent } from './components/measurement-standard-list/measurement-standard-list.component';
import { MeasurementStandardEditComponent } from './components/measurement-standard-edit/measurement-standard-edit.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatCardModule, MatProgressSpinnerModule, MatInputModule, MatIconModule, MatMenuModule, MatGridListModule, MatCheckboxModule, MatToolbarModule, MatFormFieldModule, MatSidenavModule, MatListModule, MatTableModule, MatSelectModule, MatDialogModule, MatTooltipModule, MatTabsModule, MatProgressBarModule, MatDatepickerModule, MatNativeDateModule, MatSortModule, MatChipsModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material';
import { moduleRoutes } from './module.routes';
import { RouterModule } from '@angular/router';
import { RequestSelectorComponent } from './components/request-selector/request-selector.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import {WebcamModule} from 'ngx-webcam';
import { CustomerPortalComponent } from './components/customer-portal/customer-portal.component';
import { LayoutTypeListComponent } from './components/layout-type-list/layout-type-list.component';
import { LayoutTypeEditComponent } from './components/layout-type-edit/layout-type-edit.component';
import { DoorTypeListComponent } from './components/door-type-list/door-type-list.component';
import { DoorTypeEditComponent } from './components/door-type-edit/door-type-edit.component';
import { DecorTypeComponent } from './components/decor-type/decor-type.component';
import { DecorComponent } from './components/decor/decor.component';
import { DecorListComponent } from './components/decor-list/decor-list.component';
import { DecorTypeListComponent } from './components/decor-type-list/decor-type-list.component';
import { InsideTypeListComponent } from './components/inside-type-list/inside-type-list.component';
import { InsideTypeEditComponent } from './components/inside-type-edit/inside-type-edit.component';
import { InsideEditComponent } from './components/inside-edit/inside-edit.component';
import { InsideListComponent } from './components/inside-list/inside-list.component';
import { ItemListComponent } from './components/item-list/item-list.component';
import { ItemEditComponent } from './components/item-edit/item-edit.component';
import { LayoutListComponent } from './components/layout-list/layout-list.component';
import { LayoutEditComponent } from './components/layout-edit/layout-edit.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CustomerPortalListComponent } from './components/customer-portal-list/customer-portal-list.component';
import { CustomerPortalViewComponent } from './components/customer-portal-view/customer-portal-view.component';
import { CustomerPortalLayoutViewComponent } from './components/customer-portal-layout-view/customer-portal-layout-view.component';
import { appearanceConfig } from './configs/material.config';
// import { HttpClientModule } from "@angular/common/http";
import { MatIconRegistry } from "@angular/material/icon";


@NgModule({
  declarations: [MeasurementStandardListComponent, MeasurementStandardEditComponent, RequestSelectorComponent, CustomerPortalComponent, LayoutTypeListComponent, LayoutTypeEditComponent, DoorTypeListComponent, DoorTypeEditComponent, DecorTypeComponent, DecorComponent, DecorListComponent, DecorTypeListComponent, InsideTypeListComponent, InsideTypeEditComponent, InsideEditComponent, InsideListComponent, ItemListComponent, ItemEditComponent, LayoutListComponent, LayoutEditComponent, CustomerPortalListComponent, CustomerPortalViewComponent, CustomerPortalLayoutViewComponent],
  entryComponents:[RequestSelectorComponent,CustomerPortalViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,    
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatGridListModule,   
    MatCheckboxModule,
    MatChipsModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatSortModule,
    MatSelectModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatProgressBarModule,	    
    MatDatepickerModule,
    MatNativeDateModule,        
    FlexLayoutModule,
    SharedModule,
    RouterModule.forChild(moduleRoutes),
    TranslateModule,
    InfiniteScrollModule,
    WebcamModule    
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearanceConfig
    }
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ]  
})
export class PlasardMeasurementModule { }
